module.exports = __webpack_public_path__ + "resources/images/screen3-d9e50bc4c8db808fe68860052ded5ffe-cache.png";